<template>
  <div>
      <!-- <header-box style="position:relative;z-index:10;"></header-box> -->
      <div class="container">
        <div class="login-box flex align-center">
          <div class="flex flex-1 align-center">
            <div class="flex-1">
              <div class="biaoti-box">用户登录</div>
              <div style="">
                <div style="width: 100%;height: 300px;text-align: center;">
                  <img style="width：100%;height:100%;" src="../assets/image/login.jpg" alt="">
                </div>
              </div>
            </div>
            <div class="flex-1">
              <div class="biaoti-box" style="font-weight:400;font-size:22px;">登录账号</div>
              <div style="padding: 0 50px;">
                <div>
                  <el-input prefix-icon="el-icon-user-solid"
                  style="border-bottom:1px solid #ccc;padding: 20px;"
                  placeholder="请输入账号" v-model="form.acount"></el-input>
                </div>
                <div @keyup.enter='enterLogin'>
                  <el-input prefix-icon="el-icon-unlock" placeholder="请输入密码"
                  style="border-bottom:1px solid #ccc;padding: 20px;"
                  type="password" v-model="form.password"></el-input>
                </div>
              </div>
              <div class="flex just-center">
                <div class="login-btn cursor-pointer" @click.prevent="login">登 录</div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-expressions */
/* eslint-disable no-debugger */
// eslint-disable-next-line no-unused-vars
// import echart from 'echarts'
/* eslint-disable prefer-const */
/* eslint-disable no-var */
import VueCookie from 'vue-cookies'
import JSEncrypt from 'jsencrypt'
export default {
  components: {
    // HeaderBox
  },
  data () {
    return {
      pageType: 0,
      form: {
        acount: '',
        password: ''
      },
      pubKey: '',
      REGEX: /^(?![A-Za-z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,16}$/
    }
  },
  directives: {
    focus: {
      inserted (e) {
        e.focus()
      }
    }
  },
  methods: {
    login () {
      if (this.form.acount && this.form.password) {
        // this.$router.push({
        //   path: '/manage'
        // })
        // 账号密码均输入，执行登录方法
        const param = {
          username: this.rsaEncode(this.form.acount),
          password: this.rsaEncode(this.form.password)
        }
        this.$api.login.login(param).then(res => {
          if (res && res.code === 200) {
            this.$message({
              message: '登陆成功',
              type: 'success'
            })
            // 校验当前密码是否为弱密码
            if (!this.REGEX.test(this.form.password)) {
              VueCookie.set('tempToken', res.data.id)
              localStorage.setItem('tempToken', res.data.id)
              this.$router.replace('/resetPassword')
            } else {
              VueCookie.set('token', res.data.id)
              localStorage.setItem('token', res.data.id)
              this.$router.push({
                path: '/manage'
              })
            }
            
          } else {
            this.$message({
              message: res.message,
              type: 'error'
            })
          }
        })
      // } else {
      //   this.$router.push({
      //     path: '/home'
      //   })
      //   this.$message({
      //     message: '请先输入账号和密码进行登录',
      //     type: 'error'
      //   })
      }
    },
    rsaEncode (data) {
      const jsRas = new JSEncrypt()
      jsRas.setPublicKey(this.pubKey)
      return jsRas.encrypt(data)
    },
    enterLogin (e) {
      if (e.keyCode === 13) {
        this.login()
      }
    },
    clearPass () {
      this.form.password = ''
      this.showSC = true
    },
    getPubKey () {
      this.$api.login.getPubKey().then(res => {
        if (res && res.code === 200) {
          this.pubKey = res.data
        }
      })
    }
  },
  mounted () {
    this.getPubKey()
  },
  created () {

  }
}
</script>

<style lang='less' scoped>
.container{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #23FEF6 0%, #286AE8 100%);
}
.login-box{
  min-width: 1000px;
  min-height: 534px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
}
.biaoti-box{
    margin-bottom: 40px;
    font-size: 30px;
    font-weight: 800;
    text-align: center;
    color: #128BF1;
}
.el-input{
  font-family: SourceHanSansCN-Regular-, SourceHanSansCN-Regular;
  font-weight: normal;
  color: #13FFFC;
  line-height: 28px;
  background: none;
}
.el-form-item{
  margin-top: 10px;
}
.login-btn{
  width: 357px;
  height: 51px;
  margin: 70px 0 0;
  background: #128BF1;
  border-radius: 2px 2px 2px 2px;
  opacity: 1;
  font-size: 20px;
  color:#fff;
  text-align:center;
  line-height:51px;
}
.title-box{
  font-size:20px;
  text-align:center;
  padding:43px 0 20px;
  color: #13FFFC;
}
input{
  outline: none;
  border: none;
  color: #13FFFC;
  width: 200px;
  height: 28px;
  font-size: 16px;
  caret-color: #13FFFC;
  line-height: 28px;
  background-color: rgba(0, 0, 0, 0) !important;
}
input::-webkit-input-placeholder{
  color: #066085;
}
input::-moz-input-placeholder{
  color: #066085;
}
input::-ms-input-placeholder{
  color: #066085;
}
input:-internal-autofill-previewed,
input:-internal-autofill-selected {
    -webkit-text-fill-color: #13FFFC;
    transition: background-color 5000s ease-out 0.5s;
}
.dis-hidden{
  display: none;
}
.dis-block{
  display: block;
}
/deep/ .el-input__inner{
  border: none;
  font-size: 20px;
}

/deep/ .el-input__icon{
  font-size: 26px;
  line-height: 80px;
}
/deep/ .el-input--prefix .el-input__inner{
  padding-left: 50px;
}
</style>
